import { newPropertiesStore } from "./models";

export const getInvoice = ({ dispatch }, { id, date }) => {
  return new Promise((resolve, reject) => {
    BX24.callMethod(
      "crm.invoice.get",
      {
        id: id,
      },
      function (result) {
        if (result.error()) {
          console.error(result.error());
          reject(null);
        } else {
          resolve(result.data());
        }
      }
    );
  });
};

export const updateInvoice = ({ dispatch }, { id, date }) => {
  return new Promise((resolve, reject) => {
    BX24.callMethod(
      "crm.invoice.update",
      {
        id: id,
        fields: fields,
      },
      function (result) {
        if (result.error()) {
          let alert = "Счет не провелся";
          dispatch("alertInfo", alert, { root: true });
          console.error(result.error());
        } else {
          bitrixEntityGet();
        }
      }
    );
  });
};

export const entityItemAdd = (context, payload = null) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_item_add.php
    if (!payload) {
      console.log("Нет данных для обновления");
      reject(400);
    }
    BX24.callMethod("entity.item.add", payload, function (result) {
      // console.dir (result)
      if (result.error()) {
        console.error(result.error());
        reject(400);
      } else {
        // console.log( result.data() );
        resolve(200);
      }
    });
  });
};

export const getProducts = (context) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/crm/products/crm_product_list.php

    let products = [];

    BX24.callMethod(
      "crm.product.list",
      {
        order: { NAME: "ASC" },
        filter: { CATALOG_ID: 19 },
        select: ["ID", "NAME", "CURRENCY_ID", "PRICE", "SECTION_ID"],
      },
      function (result) {
        if (result.error()) {
          console.error(result.error());
          reject(null);
        } else {
          products = products.concat(result.data());
          if (result.more()) {
            result.next();
          } else {
            resolve(products);
          }
        }
      }
    );
  });
};

export const entityItemUpdate = (context, payload = null) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_item_update.php
    if (!payload) {
      console.log("Нет данных для обновления");
      reject(400);
    }
    BX24.callMethod("entity.item.update", payload, function (result) {
      // console.dir (result)
      if (result.error()) {
        console.error(result.error());
        reject(400);
      } else {
        // console.log( result.data() );
        resolve(200);
      }
    });
  });
};

export const entityItemDelete = (context, payload = null) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_item_delete.php
    if (!payload) {
      console.log("Нет данных для обновления");
      reject(400);
    }
    BX24.callMethod(
      "entity.item.delete",
      {
        ENTITY: payload.ENTITY,
        ID: payload.ID,
      },
      function (result) {
        // console.dir (result)
        if (result.error()) {
          console.error(result.error());
          reject(400);
        } else {
          // console.log( result.data() );
          resolve(200);
        }
      }
    );
  });
};

export const getItems = (context, payload = null) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_item_get.php
    if (!payload) {
      console.log("Нет данных для запроса");
      reject(400);
    }
    let items = [];

    BX24.callMethod(
      "entity.item.get",
      {
        ENTITY: payload.ENTITY,
        FILTER: payload.FILTER,
      },
      function (result) {
        // console.dir (result)
        if (result.error()) {
          console.error(result.error());
          reject(400);
        } else {
          if (result.more()) {
            items = items.concat(result.data());
            result.next();
          } else {
            items = items.concat(result.data());
            resolve(items);
          }
        }
      }
    );
  });
};

export const getAllEntity = (context) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_get.php
    BX24.callMethod("entity.get", {}, function (result) {
      if (result.error()) {
        console.error(result.error());
        reject(null);
      } else {
        resolve(result.data());
      }
    });
  });
};

export const getTask = (context, taskId) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/tasks/task/tasks/tasks_task_get.php
    if (!taskId) {
      console.log("Не получен id Задачи");
      reject(null);
    }
    BX24.callMethod(
      "tasks.task.get",
      {
        taskId: taskId,
        select: ["*", "UF_*"],
      },
      function (result) {
        if (result.error()) {
          console.error(null);
          reject(null);
        } else {
          resolve(result.data());
        }
      }
    );
  });
};

export const getDeal = (context, dealId) => {
  // https://dev.1c-bitrix.ru/rest_help/crm/cdeals/crm_deal_get.php

  if (!dealId) {
    console.log("Не получен id сделки");
    return null;
  }

  return new Promise((resolve, reject) => {
    BX24.callMethod("crm.deal.get", { id: dealId }, function (result) {
      if (result.error()) {
        console.error(result.error());
        reject(null);
      } else {
        // console.dir( result.data() );
        resolve(result.data());
      }
    });
  });
};

export const installation = async ({ state, dispatch }) => {
  // Добавляем Хранилище и/или Новые свойства
  dispatch("getAllEntity")
    .then(async (result) => {
      // Получаем массив объектов, имя Хранилища - ENTITY
      if (!result) {
        throw "Ошибка запроса Хранилищ";
      }
      // Проверяем есть ли Хранилище store. Если нет, то Создаём
      // TODO Сделать через models
      if (!result.find((item) => item.ENTITY == "store")) {
        await dispatch("entityAdd", "store");
      }

      let newProperties = [];
      // Проверяем есть ли Хранилище accrual. Если нет, то Создаём
      if (!result.find((item) => item.ENTITY == "accrual")) {
        await dispatch("entityAdd", "accrual");
        // Здесь не нужно запрашивать свойства, но нужно проверять, что запрос выполнен успешно
        newProperties = newPropertiesStore;
        return newProperties;
      } else {
        let existProperties = await dispatch("getProperty", "accrual");
        newPropertiesStore.forEach((newItem) => {
          if (
            !existProperties.find(
              (existItem) => existItem.PROPERTY == newItem.PROPERTY
            )
          )
            newProperties.push(newItem);
        });

        return newProperties;
      }
    })
    .then((properties) => {
      // Добавляем свойства, если есть что добавлять
      if (properties) {
        properties.forEach((item) => {
          let newProperty = {
            ENTITY: "accrual",
            PROPERTY: item.PROPERTY,
            NAME: item.NAME,
            TYPE: item.TYPE,
          };
          dispatch("propertyAdd", newProperty).then((answer) => {
            if (answer == 200)
              console.log(
                "Свойство " + newProperty.NAME + " добавлено успешно"
              );
            if (answer == 400)
              console.log("Ошибка добавленя свойства " + newProperty.NAME);
          });
        });
      }
    })
    .then(() => BX24.installFinish())
    .catch((err) => console.error(err));

  let handler = state.serverUrl;
  dispatch("setAllPlacements", handler);
};

export const setAllPlacements = async ({ dispatch, state }, handler) => {
  if (!handler) handler = state.serverUrl;
  let tittleApp = "Финансы";
  let newPlacements = [
    { PLACEMENT: "CRM_DEAL_DETAIL_TAB", HANDLER: handler, TITLE: tittleApp },
    { PLACEMENT: "CRM_CONTACT_DETAIL_TAB", HANDLER: handler, TITLE: tittleApp },
    { PLACEMENT: "CRM_COMPANY_DETAIL_TAB", HANDLER: handler, TITLE: tittleApp },
    { PLACEMENT: "TASK_VIEW_TAB", HANDLER: handler, TITLE: tittleApp },
    { PLACEMENT: "USER_PROFILE_TOOLBAR", HANDLER: handler, TITLE: tittleApp },
  ];

  await dispatch("getPlacements").then((existPlacements) => {
    // console.dir(existPlacements);
    if (existPlacements) {
      newPlacements.forEach((newPlacement) => {
        // console.log( 'newPlacement.PLACEMENT ' + newPlacement.PLACEMENT);
        let comparison = existPlacements.find((existPlacement) => {
          // console.log( 'existPlacement.placement ' + existPlacement.placement);
          return existPlacement.placement == newPlacement.PLACEMENT;
        });
        if (!comparison) {
          dispatch("setPlacement", newPlacement).then((result) => {
            if (result) console.log("Встроено в : " + newPlacement.PLACEMENT);
            else newPlacement.PLACEMENT + " - уже встроно"; // TODO Это не должно выполниться
          });
        }
      });
    }
  });
};

export const setPlacement = async (context, payload) => {
  return new Promise((resolve, reject) =>
    // https://dev.1c-bitrix.ru/rest_help/application_embedding/metods/placement_bind.php
    BX24.callMethod("placement.bind", payload, (result) => {
      if (result.error()) {
        console.error(result.error());
        reject(null);
      } else {
        resolve(result.data());
      }
    })
  );
};

export const getPlacements = async () => {
  return new Promise((resolve, reject) =>
    BX24.callMethod("placement.get", {}, (result) => {
      if (result.error()) {
        console.error(result.error());
        reject(null);
      } else {
        resolve(result.data());
      }
    })
  );
};

export const getDealAndCompanyByTask = async ({ dispatch }, taskId) => {
  // По id задачи получаем информацию о задаче
  let resultTask = await dispatch("getTask", taskId);
  let task = resultTask ? resultTask.task : null;

  if (!task) {
    console.log("Не получена информация о задаче");
    return null;
  }

  // Смотрим и разбираем поле Привязка к CRM
  let taskCRM = getCRMelement(task.ufCrmTask);

  let contactId = taskCRM.contactFirstId();

  let companyId = taskCRM.companyFirstId();

  let dealId = taskCRM.dealFirstId();

  let resultDeal = await dispatch("getDeal", dealId);

  let deal = resultDeal ? resultDeal : null;

  // CONTACT_ID
  // COMPANY_ID
  if (deal) companyId = deal.COMPANY_ID ? deal.COMPANY_ID : null;

  return [dealId, companyId];
};

export const getAllUsers = (context, id = null) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/users/user_get.php
    let filter = id ? { ID: id, ACTIVE: true } : { ACTIVE: true };
    let users = [];
    BX24.callMethod(
      "user.get",
      {
        sort: "LAST_NAME",
        order: "ASC",
        filter,
      },
      function (result) {
        if (result.error()) {
          console.error(result.error());
          reject(null);
        } else {
          if (result.more()) {
            users = users.concat(result.data());
            result.next();
          } else {
            users = users.concat(result.data());
            resolve(users);
          }
        }
      }
    );
  });
};

export const getProperty = (context, entity) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_item_property_get.php
    BX24.callMethod(
      "entity.item.property.get",
      {
        ENTITY: entity,
      },
      function (result) {
        if (result.error()) {
          console.error(result.error());
          reject(null);
        } else {
          resolve(result.data());
        }
      }
    );
  });
};

export const deleteEntity = (context, entity) => {
  return new Promise((resolve, reject) => {
    BX24.callMethod("entity.delete", { ENTITY: entity }, function (result) {
      if (result.error()) {
        reject(console.log("Хранилища не удалено, возможно его и не было"));
      } else {
        resolve(console.log("Хранилище Б24 удалено"));
      }
    });
  });
};

export const entitySectionGet = (context, entity, filter) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_section_get.php
    BX24.callMethod(
      "entity.section.get",
      {
        ENTITY: entity,
        FILTER: filter,
      },
      function (result) {
        if (result.data()) {
          resolve(result.data());
        } else {
          reject(result.error());
        }
      }
    );
  });
};

export const entityAdd = (context, name = null) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_add.php
    if (!name) {
      console.log("Не указано название хранилища");
      reject(null);
    }
    BX24.callMethod(
      "entity.add",
      {
        ENTITY: name,
        NAME: name,
        ACCESS: { AU: "W" },
      },
      function (result) {
        if (result.error()) {
          console.log(result.error());
          reject(400);
        } else {
          // console.log( result );
          resolve(200);
        }
      }
    );
  });
};

export const entitySectionAdd = (context, newSection = {}) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_section_add.php
    BX24.callMethod(
      "entity.section.add",
      {
        ENTITY: newSection.ENTITY,
        NAME: newSection.NAME,
      },
      function (result) {
        if (result) {
          resolve(result);
        } else {
          reject(result.error());
        }
      }
    );
  });
};

export const propertyAdd = (context, newProperty = {}) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_item_property_add.php
    BX24.callMethod("entity.item.property.add", newProperty, function (result) {
      if (result.error()) {
        console.dir(result);
        reject(400);
      } else {
        // console.dir (result)
        resolve(200);
      }
    });
  });
};

export const addAllProperties = (context) => {
  return new Promise((resolve, reject) => {
    // https://dev.1c-bitrix.ru/rest_help/entity/entity_item_property_add.php
    // https://dev.1c-bitrix.ru/rest_help/js_library/rest/callBatch.php

    const entity = "store";

    BX24.callBatch(
      [
        {
          method: "entity.item.property.add",
          params: {
            ENTITY: entity,
            PROPERTY: "property",
            NAME: "name",
            TYPE: "S",
          },
        },
      ],

      function (result) {
        if (result) {
          resolve(console.log(result));
        } else {
          reject(console.log(result));
        }
      }
    );
  });
};

function getCRMelement(elements) {
  let output = {
    contacts: [],
    deals: [],
    companies: [],
    contactsTxtIds() {
      if (this.contacts.length) {
        return this.contacts.join();
      } else return null;
    },
    contactFirstId() {
      if (this.contacts.length) {
        return this.contacts[0];
      } else return null;
    },
    dealsTxtIds() {
      if (this.deals.length) {
        return this.deals.join();
      } else return null;
    },
    dealFirstId() {
      if (this.deals.length) {
        return this.deals[0];
      } else return null;
    },
    companiesTxtIds() {
      if (this.companies.length) {
        return this.companies.join();
      } else return null;
    },
    companyFirstId() {
      if (this.companies.length) {
        return this.company[0];
      } else return null;
    },
  };
  // let regexpDeals = '/(?<=D_)(\d+)/gi'
  // let regexpCompanies = '/(?<=C_)(\d+)/gi'
  // let regexpContacts = '/(?<=CO_)(\d+)/gi'
  let regexpType = /\w+(?=_)/g;
  let regexpId = /(?<=_)\d+/g;

  // TODO Перебор массива
  if (elements) {
    elements.map((item) => {
      // Рзбираем регуляркой элемент на тип и id
      let itemType = item.match(regexpType) ? item.match(regexpType)[0] : null;
      let itemId = item.match(regexpId) ? item.match(regexpId)[0] : null;
      // Проверяем тип элемента
      switch (itemType) {
        case "CO":
          output.contacts.push(itemId);
          break;
        case "C":
          output.companies.push(itemId);
          break;
        case "D":
          output.deals.push(itemId);
          break;
        default:
          console.log(
            "Ошибка распознования элемента CRM. Сообщите разработчику."
          );
          break;
      }
    });
  }
  return output;
}

// BX24.callBatch({
//     get_user: ['user.current', {}],
//     get_department: {
//         method: 'department.get',
//         params: {
//             ID: '$result[get_user][UF_DEPARTMENT]'
//         }
//     }
// }, function(result)
// {
//     var l = result.get_department.data().length;
//     var str = 'Текущий пользователь ' + result.get_user.data().NAME + ' ' + result.get_user.data().LAST_NAME + ' приписан к подразделени' + (l > 1 ? 'ям ' : 'ю ');

//     for(var i = 0; i < l; i++)
//     {
//         str += i == 0 ? '' : ', ';
//         str += result.get_department.data()[i].NAME;
//     }

//     alert(str);
// });
